import {useMutationAsUser} from "../../clients/graphql/graphql.hooks";
import {
  calculatePortfolioHistorySequences,
  calculatePositionHistorySequences
} from "../../clients/graphql/views/positions-queries";
import {useCallback} from "react";

export function useCalculatePositionHistorySequences(userKey: string | undefined, portfolioKey: string | undefined) {
  if (userKey === undefined) {
    throw new Error("Must supply a userKey")
  }

  const [recalcMutation, { loading, error }] = useMutationAsUser(
    calculatePositionHistorySequences, {
      userKey: parseInt(userKey || '0'), // stable header/context concern
      // do NOT put variables here if they are dynamic per call
    }
  );

  const calculatePositionHistorySequencesAPI = useCallback(
    (positionKey: string) => {
      console.log("calculatePositionHistorySequencesAPI", positionKey)
      return recalcMutation({
        variables: {
          portfolioKey: parseInt(portfolioKey || '0'),
          positionKey: parseInt(positionKey),
        },
        // Optional: refetchQueries / optimisticResponse / update
      })
    },
    [recalcMutation, portfolioKey]
  );

  return { calculatePositionHistorySequencesAPI, loading, error };
}

export function useCalculatePortfolioHistorySequences(userKey: string | undefined, portfolioKey: string | undefined) {
  const [mutate, { loading, error }] = useMutationAsUser(
    calculatePortfolioHistorySequences, {
      userKey: parseInt(userKey || '0'),
      variables: {
        portfolioKey: parseInt(portfolioKey || '0')
      }
    }
  );

  return { mutate, loading, error };
}
